import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { FullPageLoader, ProtectedRoute } from "./components";
import { UnauthorizedPage } from "./pages/common";

export enum ERoutes {
  home = "/home",
  translations = "/translations",
  notFound = "/404",
  unauthorized = "/401",
  users = "/users",
  mailTemplates = "/mailTemplates",
  mailTemplateTypes = "/mailTemplateTypes",
  appeals = "/appeals",
}

const getEditRoute = (base: ERoutes) => {
  return `${base}/:id/:tab/:state?`;
};

const MailTemplateItemPage = React.lazy(
  () => import("./pages/mailTemplates/item/MailTemplateItemPage")
);
const MailTemplateListPage = React.lazy(
  () => import("./pages/mailTemplates/list/MailTemplateListPage")
);

const MailTemplateTypeItemPage = React.lazy(
  () => import("./pages/mailTemplateTypes/item/MailTemplateTypeItemPage")
);

const TranslationEditPage = React.lazy(
  () => import("./pages/translation/TranslationEditPage")
);

const UserListPage = React.lazy(
  () => import("./pages/users/list/userListPage")
);
const UserItemPage = React.lazy(
  () => import("./pages/users/item/userItemPage")
);

const AppealsPage = React.lazy(
  () => import("./pages/appeals/list/AppealListPage")
);

const AppealDetail = React.lazy(
  () => import("./pages/appeals/detail/PrivateAppealDetail")
);

export const AppRouter = () => {
  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <Switch>
        <ProtectedRoute
          path={`${ERoutes.translations}`}
          component={TranslationEditPage}
        />
        <ProtectedRoute
          path={`${ERoutes.users}`}
          component={UserListPage}
          exact={true}
        />
        <ProtectedRoute
          path={getEditRoute(ERoutes.users)}
          exact={true}
          component={UserItemPage}
        />
        <ProtectedRoute
          path={`${ERoutes.mailTemplates}`}
          component={MailTemplateListPage}
          exact={true}
        />
        <ProtectedRoute
          path={getEditRoute(ERoutes.mailTemplates)}
          exact={true}
          component={MailTemplateItemPage}
        />
        <ProtectedRoute
          path={getEditRoute(ERoutes.mailTemplateTypes)}
          exact={true}
          component={MailTemplateTypeItemPage}
        />
        <ProtectedRoute
          path={ERoutes.appeals}
          exact={true}
          component={AppealsPage}
        />

        <ProtectedRoute
          path={ERoutes.appeals + "/:id/:step?"}
          exact={true}
          component={AppealDetail}
        />

        <ProtectedRoute
          path={ERoutes.appeals}
          exact={true}
          component={React.lazy(
            () => import("./pages/appeals/list/AppealListPage")
          )}
        />
        <Route path={`${ERoutes.unauthorized}`} component={UnauthorizedPage} />

        <Redirect to={ERoutes.appeals} exact />
      </Switch>
    </React.Suspense>
  );
};
